import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    medicineRequestDetail: -1,
    medicineApprove: -1,
  },
  medicineRequestDetail: {},
  error: {
    medicineRequestDetail: null,
    medicineApprove: null,
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.MEDICINE_REQUEST_DETAIL_REQUESTED:
      return {
        ...state,
        status: {
          medicineRequestDetail: 0,
        },
        error: {
          medicineRequestDetail: null,
        },
      };
    case ACTION_TYPES.MEDICINE_REQUEST_DETAIL_SUCCEED:
      return {
        ...state,
        status: {
          medicineRequestDetail: 1,
        },
        medicineRequestDetail: payload.data,
      };
    case ACTION_TYPES.MEDICINE_REQUEST_DETAIL_FAILED:
      return {
        ...state,
        status: {
          medicineRequestDetail: 2,
        },
        error: {
          medicineRequestDetail: error,
        },
      };

    case ACTION_TYPES.MEDICINE_REQUEST_APPROVE_REQUESTED:
      return {
        ...state,
        status: {
          medicineApprove: 0,
        },
        error: {
          medicineApprove: null,
        },
      };
    case ACTION_TYPES.MEDICINE_REQUEST_APPROVE_SUCCEED:
      return {
        ...state,
        status: {
          medicineApprove: 1,
        },
      };
    case ACTION_TYPES.MEDICINE_REQUEST_APPROVE_FAILED:
      return {
        ...state,
        status: {
          medicineApprove: 2,
        },
        error: {
          medicineApprove: error,
        },
      };
    default:
      return state;
  }
}
